import axios, { AxiosResponse } from "axios";
import { Place } from "../../types";
import api from "../api";
import debug from "../debug";

export let NATIONALITIES: Place[] = [];

let nationalitiesPromise: Promise<Place[]>;

/**
 * Load the country place data from a URL (string) or from an array of place objects.
 */
export async function loadNationalities(
  input?: null | string | Place[]
): Promise<Place[]> {
  // Already loaded
  if (NATIONALITIES.length > 0) {
    return NATIONALITIES;
  }

  //debug("[utils/nationalities] loading nationalities...");

  // Load via URL
  if (typeof input === "string" && input) {
    debug("[utils/nationalities] Loading the country data from URL", { input });

    const receivednationalities = await axios
      .get(input)
      .then((res: AxiosResponse) => res.data);

    NATIONALITIES = receivednationalities;
  }
  // Load using dataset given
  else if (input instanceof Array) {
    debug("[utils/nationalities] Using supplied country data", { input });

    NATIONALITIES = input;
  }
  // Load via API
  else {
    //debug("[utils/nationalities] Loading the country data from API");
    if (!nationalitiesPromise) {
      nationalitiesPromise = api.getNationalities();
    }
    const receivednationalities = await nationalitiesPromise;
    NATIONALITIES = receivednationalities;
  }

  //debug("[utils/nationalities] loaded nationalities", { nationalities });

  return NATIONALITIES;
}
